import { createAction } from '@reduxjs/toolkit'

import {
    curryPayloadActionForPath,
    curryEmptyPayloadActionForPath,
    PathActionEmptyPayload,
    PathActionPayload,
} from 'helpers/curry'

// Mounting
export const mountTabRequest = createAction<
    PathActionPayload<{
        active: boolean
        mounting: boolean
    }>
>('MOUNT_TAB_REQUEST')

export const mountTabSuccess =
    createAction<PathActionEmptyPayload>('MOUNT_TAB_SUCCESS')

export const mountTabFailure =
    createAction<PathActionPayload<Error>>('MOUNT_TAB_FAILURE')

export const makeMountTabRequest = curryPayloadActionForPath(mountTabRequest)

// Fetch data
export const fetchTabDataRequest = createAction<PathActionEmptyPayload>(
    'FETCH_TAB_DATA_REQUEST'
)

export const fetchTabDataSuccess = createAction<PathActionEmptyPayload>(
    'FETCH_TAB_DATA_SUCCESS'
)
export const fetchTabDataFailure = createAction<PathActionPayload<Error>>(
    'FETCH_TAB_DATA_FAILURE'
)

export const makeFetchTabDataRequest =
    curryEmptyPayloadActionForPath(fetchTabDataRequest)
